import React from 'react';
import { FC, useState } from 'react';
import { menuBar, menuIcon } from '../styles';
import {motion} from 'framer-motion';
import settings from '@settings';

type MenuIconProps = {
	showMenu: boolean,
	setShowMenu: (showMenu: boolean) => void,
	color: string
}

const MenuIcon: FC<MenuIconProps> = ({showMenu, setShowMenu, color}) => {
	const [isHovered, setIsHovered] = useState(false);

	return (
		<motion.div 
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			onClick={() => setShowMenu(!showMenu)}
			css={menuIcon}
		>
			<motion.div 
				animate={showMenu ? {rotate: '-135Deg', y: 6, backgroundColor: color } : {rotate: 0, y: 0, backgroundColor: color}} 
				transition={{duration: 0.5, ease: 'easeOut'}} 
				css={[menuBar, {width: isHovered || showMenu ? '24px' : '18px'}]} 
			/>
			<motion.div 
				animate={showMenu ? {rotate: '135Deg', y: 6, backgroundColor: color } : {rotate: 0, y: 6, backgroundColor: color}} 
				transition={{duration: 0.5, ease: 'easeOut'}} 
				css={[menuBar, {width: isHovered || showMenu  ? '24px' : '24px'}]} 
			/>
			<motion.div 
				animate={showMenu ? {rotate: '135Deg', y: 6, backgroundColor: color } : {rotate: 0, y: 12, backgroundColor: color}} 
				transition={{duration: 0.5, ease: 'easeOut'}} 
				css={[menuBar, {width: isHovered || showMenu  ? '24px' : '12px'}]} 
			/>
		</motion.div>
	);
};

export default MenuIcon;